import React from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

export const MobileNavigationBar = ({
  sideMenuOpen,
  setSideMenuOpen,
  categories,
  isServices,
  isRestaurantMerchant,
  merchantMeta,
  isHybridMerchant,
}: any) => {
  return (
    <Dialog open={sideMenuOpen} onClose={setSideMenuOpen} className="sm:hidden">
      <div className="fixed inset-0 z-30" />
      <DialogPanel className="fixed inset-y-0 right-0 z-30 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div className="flex items-center justify-between">
          <a href="#" className="-m-1.5 p-1.5">
            <Bars3Icon />
          </a>
          <button
            type="button"
            onClick={() => setSideMenuOpen(false)}
            className="-m-2.5 rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>
        <div className="mt-6 flow-root">
          <div className="-my-6 divide-y divide-gray-500/10">
            <div className="space-y-2 py-6">
              {merchantMeta?.selectedSetup !== "Simple" && (
                <Link
                  href="/about"
                  className={[
                    "-mx-3 block rounded-lg px-3 py-2 leading-7 text-gray-900 hover:bg-gray-50",
                    "font-normal text-base leading-6",
                  ].join(" ")}
                  onClick={() => setSideMenuOpen(false)}
                >
                  About
                </Link>
              )}
              {isHybridMerchant ? (
                <>
                  <Link
                    href="/services"
                    className={[
                      "-mx-3 block rounded-lg px-3 py-2 leading-7 text-gray-900 hover:bg-gray-50",
                      "font-normal text-base leading-6",
                    ].join(" ")}
                    onClick={() => setSideMenuOpen(false)}
                  >
                    Services
                  </Link>
                  <Link
                    href="/shop"
                    className={[
                      "-mx-3 block rounded-lg px-3 py-2 leading-7 text-gray-900 hover:bg-gray-50",
                      "font-normal text-base leading-6",
                    ].join(" ")}
                    onClick={() => setSideMenuOpen(false)}
                  >
                    Shop
                  </Link>
                </>
              ) : (
                categories.map((c: { id: string; name: string }) => (
                  <Link
                    key={c.id}
                    href={
                      isServices
                        ? `/services/all#${c.name}`
                        : isRestaurantMerchant
                        ? `/menu/all#${c.name}`
                        : `/${c.name}`
                    }
                    className={[
                      "-mx-3 block rounded-lg px-3 py-2 leading-7 text-gray-900 hover:bg-gray-50",
                      "font-normal text-base leading-6",
                    ].join(" ")}
                    onClick={() => setSideMenuOpen(false)}
                  >
                    {c.name}
                  </Link>
                ))
              )}
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
};
